<template>
    <div id="lMyMTraining">
        <div>
            <div class="lMyMTrainingFirst1" >
                <div class="lMyMTrainingFirstTitle">二类专业学时</div>
                <div class="laddressFirstBtn" @click="newTwoperiod()">新增</div>
            </div>
            <div>
                <Table :columns="columns1" :data="data1">
                    <template slot-scope="{row,index}" slot="action">
                        <div>
                            <Button type="primary" style="margin-right:10px" v-if="row.state==2" size="small" ghost @click="getLive(row)">审核信息</Button>
                            <Button type="primary" style="margin-right:10px" size="small" v-if="row.state==0||row.state==2" ghost @click="toLive(row)">编辑</Button>
                            <Button type="primary" size="small" v-if="row.state==0||row.state==2" ghost @click="delLive(row)">删除</Button>
                        </div>
                    </template>
                </Table>
                <div class="ivu-mt ivu-text-center">
                    <Page :total="dataCount" :page-size="pageSize" :current.sync="current" show-elevator show-total class="paging" @on-change="changepage" @on-page-size-change="changepagesize"></Page>
                </div>
            </div>
            <Modal v-model="modal" title="审核意见">
                <p>{{suggestion}}</p>
            </Modal>
        </div>
    </div>
</template>

<script>
    import {
        querySelfPeriod,
        delSelfPeriod
    } from "../../../network/LPersonal";

    import Cookies from "js-cookie";

    export default {
        data() {
            return {
                cityList: [],
                queryInfo: {
                    yearNum: "",
                    curPage: 1,
                    maxPage: 10,
                },
                suggestion:null,
                historyData: [],
                current: 1,
                boQuery: false,
                modal: false,
                ajaxHistoryData: [],
                // 初始化信息总条数
                dataCount: 0,
                // 每页显示多少条
                pageSize: 10,
                //总共多少页
                totalTs: 1,

                columns1: [{
                        title: "专业",
                        key:"majorName",
                    },
                    {
                        title: "年度",
                        key:"year",
                       width:80,
                    },
                    {
                        title: "项目",
                        key:"name",
                        width:250
                    },
                    {
                        title: "学时",
                        key:"periodNum",
                       width:80,
                    },
                    {
                        title: "状态",
                       align:"center",
                       width:100,
                        render(h, params) {
                            if (params.row.state == 0) {
                                return h(
                                    "span", {
                                        style: {
                                            color: "#888",
                                        },
                                    },
                                    "未审核"
                                );
                            }else if (params.row.state == 1) {
                                return h(
                                    "span", {
                                        style: {
                                            color: "#3562E8",
                                        },
                                    },
                                    "审核成功"
                                );
                            } else if (params.row.state == 2) {
                                return h(
                                    "span", {
                                        style: {
                                            color: "red",
                                        },
                                    },
                                    "审核失败"
                                );
                            }
                        },
                    },
                    {
                        title: "操作",
                        slot: "action",
                        align:"center",
                         width:220,
                    },
                ],
                data1: [],
                userTye: "", //账户类型  0 个人  1企业
            };
        },
        created() {
            this.getData();
            this.$emit("editPage", "学时管理", "二类专业学时");
            this.userTye = this.Get("type");
            this.time()
        },
        activated() {
            this.getData();
            this.$emit("editPage", "学时管理", "二类专业学时");
            this.time()
        },
        methods: {
            getLive(e){
                this.suggestion = e.suggestion
                this.modal = true
            },
            delLive(row){
                console.log(row);
                delSelfPeriod({
                    selfStudyId:row.id
                }).then(res=>{
                    console.log(res,"删除");
                    if(res.data.code==200){
                        this.$Message.success(res.data.msg);
                        this.getData()
                    }
                })
            },
            newTwoperiod(){
                this.$router.push("/newTwoperiod")
            },
            //分页器
            handleListApproveHistory() {
                // 保存取到的所有数据
                this.ajaxHistoryData = this.data1;
                // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
                if (this.data1.length < this.pageSize) {
                    this.historyData = this.ajaxHistoryData;
                } else {
                    this.historyData = this.ajaxHistoryData.slice(0, this.pageSize);
                }
            },
            changepage(index) {
                this.current = index;
                var _start = (index - 1) * this.pageSize;
                var _end = index * this.pageSize;
                this.historyData = this.ajaxHistoryData.slice(_start, _end);
                this.getData();
            },
            changepagesize(pageSize) {
                this.pageSize = pageSize;
                this.getData();
                this.handleListApproveHistory()
            },

            Get(name) {
                return Cookies.get(`admin-${name}`);
            },
            time() {
                var myDate = new Date();
                var year = myDate.getFullYear(); //获取当前年
                this.yearsModel = year;
                this.initSelectYear(year);
            },
            initSelectYear(year) {
                this.yearsArr = [];
                this.cityList.push({
                    label: '全部',
                    value: -1
                })
                for (let i = 0; i < 30; i++) {
                    this.cityList.push({
                        value: year - i,
                        label: year - i + "年"
                    });
                }
            },
            getData() {
                querySelfPeriod().then((res) => {
                    this.data1 = res.data.data;
                    this.handleListApproveHistory();
                    this.dataCount = res.data.data.length;
                });
            },
            yearChange(v) {
                this.queryInfo.yearNum = v;
                this.current = 1;
                this.getData();
            },
            toLive(row) {
                this.$router.push({name: 'NewTwoperiod',params:{list:row}})
            },
        },
    };
</script>

<style>
    @import url("../../../assets/css/liucss/myTraining.css");
    .ivu-text-center{
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
    }
    .lMyMTrainingFirst1{
        display: flex;
        justify-content: space-between;
        margin-bottom: 30px;
    }
</style>